const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

function openCart() {
  const drawer = $('.cart-drawer');
  if (!drawer) return;
  drawer.setAttribute('aria-hidden', 'false');
  const b = $('.drawer-backdrop');
  if (b) b.hidden = false;
  document.body.classList.add('drawer-open');
}

function closeCart() {
  $('.cart-drawer')?.setAttribute('aria-hidden', 'true');
  const b = $('.drawer-backdrop');
  if (b) b.hidden = true;
  document.body.classList.remove('drawer-open');
}

function fireAddToCart(form) {
  if (typeof fbq !== 'function') return;
  const id = form.dataset.productId;
  const title = form.dataset.productTitle;
  const price = Number(form.dataset.productPrice) / 100;
  const currency = form.dataset.currency || 'TRY';
  if (!id) return;
  fbq('track', 'AddToCart', {
    content_ids: [id],
    content_name: title,
    content_type: 'product',
    value: price,
    currency: currency
  });
}

async function fireInitiateCheckout() {
  if (typeof fbq !== 'function') return;
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    fbq('track', 'InitiateCheckout', {
      content_ids: cart.items.map(i => String(i.product_id)),
      contents: cart.items.map(i => ({ id: String(i.product_id), quantity: i.quantity, item_price: i.price / 100 })),
      value: cart.total_price / 100,
      currency: cart.currency
    });
  } catch (e) {}
}

function syncConsent() {
  const consent = $('.cart-drawer [data-consent]');
  const checkout = $('.cart-drawer .checkout-button');
  if (!consent || !checkout) return;
  const off = !consent.checked;
  checkout.setAttribute('aria-disabled', String(off));
  checkout.classList.toggle('disabled', off);
}

async function refreshCart(open = true) {
  const drawer = $('.cart-drawer');
  const wasOpen = drawer?.getAttribute('aria-hidden') === 'false';
  const res = await fetch('/?section_id=cart-drawer', { headers: { Accept: 'text/html' } });
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const next = $('.cart-drawer', doc);
  if (next && drawer) drawer.replaceWith(next);
  const count = $('.drawer-count', doc)?.textContent?.trim() || '0';
  $$('.cart-count').forEach((x) => {
    x.textContent = count;
    x.hidden = count === '0';
  });
  syncConsent();
  if (open || wasOpen) openCart();
}

async function add(form) {
  const button = form.querySelector('button[type=submit]');
  if (button) {
    button.disabled = true;
    button.dataset.label = button.dataset.label || button.textContent;
    button.textContent = 'Ekleniyor…';
  }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('add');
    await refreshCart(true);
    fireAddToCart(form);
    if (button) button.textContent = 'Sepete eklendi ✓';
  } catch (e) {
    if (button) button.textContent = 'Tekrar deneyin';
  } finally {
    if (button) {
      button.disabled = false;
      setTimeout(() => {
        if (button.dataset.label) button.textContent = button.dataset.label;
      }, 1400);
    }
  }
}

let busy = false;
async function changeLine(line, quantity) {
  if (busy) return;
  busy = true;
  const drawer = $('.cart-drawer');
  drawer?.classList.add('is-busy');
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    await refreshCart(true);
  } finally {
    busy = false;
    $('.cart-drawer')?.classList.remove('is-busy');
  }
}

document.addEventListener('click', (e) => {
  const target = e.target instanceof Element ? e.target : null;
  if (!target) return;

  if (target.closest('.cart-open')) {
    e.preventDefault();
    openCart();
    refreshCart(true);
    return;
  }
  if (target.closest('.cart-close') || target.classList.contains('drawer-backdrop')) {
    closeCart();
    return;
  }

  const qtyButton = target.closest('[data-qty]');
  if (qtyButton) {
    const row = qtyButton.closest('[data-line]');
    if (row) {
      e.preventDefault();
      changeLine(Number(row.dataset.line), Number(qtyButton.dataset.qty));
    }
    return;
  }

  const checkout = target.closest('.checkout-button');
  if (checkout) {
    const consent = $('.cart-drawer [data-consent]');
    if (consent && !consent.checked) {
      e.preventDefault();
      const box = consent.closest('.consent');
      box?.classList.add('shake');
      setTimeout(() => box?.classList.remove('shake'), 500);
      return;
    }
    fireInitiateCheckout();
    return;
  }

  if (target.closest('[data-menu-toggle]')) {
    const m = $('.mobile-menu');
    if (m) m.hidden = !m.hidden;
  }
});

document.addEventListener('change', (e) => {
  if (e.target instanceof Element && e.target.matches('[data-consent]')) syncConsent();
});

document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.quick-add,.product-form')) return;
  e.preventDefault();
  add(form);
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeCart();
});

document.addEventListener('DOMContentLoaded', syncConsent);
